import { forwardRef } from 'react';
import { UnderlineMarkdownLongText } from './MarkdownUnderline';
import { OutlineMarkdownLongText } from './MarkdownOutline';

export const MarkdownLongText = forwardRef(({ variant, ...props }, ref) => {
  const VariantLongText =
    variant === 'underline'
      ? UnderlineMarkdownLongText
      : OutlineMarkdownLongText;
  return <VariantLongText ref={ref} {...props} />;
});
